import { RuleEngineLegacyEntities } from '@bimser/components/dist/BCRuleManager';
import { Event } from 'json-rules-engine';

export function convertEvent(
	actions: RuleEngineLegacyEntities.IBaseAction[],
	rule: RuleEngineLegacyEntities.IRule,
	getFactKeys: (factKey: string) => void
): Event {
	actions.forEach(action => {
		switch (action.typeName) {
			case 'ValueAssignActionWithEntry':
			case 'ValueAssignActionWithSelection': {
				const castedAction =
					action as RuleEngineLegacyEntities.IValueAssignActionWithSelection;
				const fieldFact = [castedAction.field.name, castedAction.field.propertyName].join(
					'.'
				);
				if (getFactKeys) {
					getFactKeys(fieldFact);
				}
			}
		}
	});

	return {
		type: 'conditionProvided',
		params: {
			actions,
			rule
		}
	};
}
